import { featureToggle } from "@faire/web/common/settings/declarations/featureToggle";

/**
 * Enable inline context display within messenger conversations to show relevant
 * information directly in the message stream.
 */
export const FE_ENABLE_MESSENGER_INLINE_CONTEXT_250610 = featureToggle({
  name: "FE_ENABLE_MESSENGER_INLINE_CONTEXT_250610",
  identifier: "UserToken",
  client: ["MAKER", "RETAILER"],
  notifyAfter: "2025-07-01",
  defaultValue: false,
  productArea: "MESSENGER",
});
